
import { RideitNotice, DisplayedNoticeStatus } from '@/models/Rideit/RideitNotice';
import { IDataTableHeader, IDataTableItemsSlotProps } from '@/typings/dataTable';
import DateHelper, { DateValue } from '@/util/DateHelper';
import {Component, Prop, Vue} from 'vue-property-decorator';
import RideitNoticeStatus from './RideitNoticeStatus.vue';

export interface INoticeTableItem {
  createdAt: DateValue;
  notice: RideitNotice;
  destinations: string;
  passengerGroups: string;
  displayedStatus: DisplayedNoticeStatus;
}

@Component({
  components: {
    RideitNoticeStatus,
  }
})
export default class RideitNoticesTableItem extends Vue {

  @Prop({ required: true }) private item: INoticeTableItem;
  @Prop({ required: true }) private headers: IDataTableHeader[];
  @Prop({ required: true }) private props: IDataTableItemsSlotProps;

  dateHelper = new DateHelper();

  get createdAt() {
    return this.dateHelper.formatDateShort(this.item.notice.createdAt);
  }

  getCellClass(value: string) {
    if (value === 'actions') {
      return 'notice-cell-actions';
    }
    if (value === 'displayedStatus') {
      return 'notice-cell-status';
    }
    return 'notice-cell-truncate';
  }

  editNotice() {
    this.$emit('edit-notice', structuredClone(this.item.notice));
  }


}
